class RuntimeContext {
    eventBroker;
    params;
    constructor(eventBroker) {
        this.eventBroker = eventBroker;
        this.params = {
            brand: "generic"
        };
    }

    setParams(newParams) {
        this.params = newParams;
        if (this.params.visitId == undefined || this.params.visitId == "0") {
            this.params.visitId = this.#getRandomString();
        }
    }

    getContentUrl() {
        if (this.params.contentUrl)
            return this.params.contentUrl;
        return "/content/" + this.params.brand.toLowerCase() + "/";
    }

    fireValueChangedEvents() {
        for (var paramIndex in this.params) {
            this.eventBroker.fireValueChanged("url", paramIndex, this.params[paramIndex]);
        }

        if (this.params.monthlySpending) {
            this.eventBroker.fireValueChanged("url", "monthlySpendingNegative", -this.params.monthlySpending);
        }
    }

    #getRandomString() {
        var result = [];
        var strLength = 10;
        var charSet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        while (--strLength) {
            result.push(charSet.charAt(Math.floor(Math.random() * charSet.length)));
        }
        return result.join('');
    }
}

export { RuntimeContext }